import React from "react";
import { Component } from "react";
import Moment from 'moment';
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { InputField, CustomSearchableSelectKeyValue }  from "../../../common/custom-form/input-filter-component";
import { ACTION_TYPES, MAX_LENGTH, Selected_Index } from "../../../../constants/external-constants";
import { inventoryCostAllocationActions } from "../../../../store/external/inventory/add-cost-allocation.reducer";
import Translation from "../../../common/translation/translation.component";
import TableWithButton from "../../../common/details-table/table-with-button.component"
import { ConfirmationNotificationModal } from "../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../common/modal/notification-modal.component";
import { CONFIRMATION_VALUE, REQUEST_TYPES_ID, } from "../../../../utils/constant.utils";
import { CustomDropdown } from "../../../common/custom-form/custom-dropdown.component";
import { hasObjectWithProperty, isDisabledPerRequestType, convertToTimeZoneDate } from "../../../../utils/helpers.utils";
import CustomSearchableDropdownWrapper from "../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class AddCostAllocation extends Component {
    constructor(props) {
        super(props);
        const modifiedCostcenterOptions = this.modifyOption(props.costcenterOptions);
        this.state = {
            inputValue: "",
            viewDetailPage: false,
            titleBtn: false, 
            enableAddBtn: false,
            showCostAllocatioDetails: false,
            updateCostAllocationDetails: false,
            enableEdit: false,
            keyIndex:null,
            selectedGlCodeKey: "",
            selectedCostCenterKey: "",
            selectedValue: '',
            activeDropdown: false,
            showDetails: false,
            modalMessage: "",
            showModal: false,
            dataTable: [],
            glCodeValid: true,
            costCenterValid: true,
            isExist: false,
            isGreater: false,
            selectedGlCode: null,
            selectedCostCenter: null,          
            fieldChange: false,
            glCode:"", 
            costCenter:"", 
            percent:"",
            loading:true,
            totalCostCodePercent:0,
            percentValue:"",
            tableLength:0,
            optionsMap: {
                "GLCode": [],
                "CostCode": []
            },
            selectedItems:{
                GLCode: "",
                GLCodeName: "",
                CostCode: "",
                CostCodePercent: "",
                CompanyCode: "",

            },
            data: {
                GLCode: '',
                CostCode: '',
                CostCodePercent: 0,
                GLCodeName: '',
                CompanyCode: '',
                CostCodeID: '',
                GLCodeID: '',
                LastModified: ''
            },
            showNotif: false,
            notifTitle: null,
            isAddPercent: false,
            isUpdatePercent: false,
            isUpdateGl_Cost: false,
            isAddGL_Cost: false,
            haveError: false
        }
    }

    handleCancel = () => {
        const { toggleDropdown } = this.props;
        toggleDropdown(Selected_Index.i_Seven);
        this.toggleActiveState();
        this.setState({
            glCode: '',
            costCenter: '',
            percent: '',
            updateCostAllocationDetails: false,
            enableEdit: false,
            keyIndex: null,
            isGreater:false,
            isExist:false,
            enableAddBtn: false,
            isAddPercent: false,
            isUpdatePercent: false,
            isAddGL_Cost: false,
            isUpdateGl_Cost: false,
        })
        this.resetMainForm();
    }

    async componentDidMount() {
        const { circuitId, getAddCostAllocation, isCircuitOrder, costAllocationTableLength, getTableCircuitGlCodeList, getTableCircuitCostCenterList } = this.props;

        await getTableCircuitGlCodeList(1);
        await getTableCircuitCostCenterList(1);

        if(isCircuitOrder)
        {
            this.setState({ tableLength: costAllocationTableLength })
        }
        else
        {
            getAddCostAllocation(circuitId).then(() =>{
                const { circuitCostAllocation } = this.props.inventoryCostAllocation; 
                const tableLength = circuitCostAllocation?.datatable?.[0]?.dataItem?.length;
                    this.setState({tableLength})
                }); ;
        }
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    }
    
    resetMainForm() {
        this.props.FormChange('inventoryCircuitCostAllocationForm.GLCode', '');
        this.props.FormChange('inventoryCircuitCostAllocationForm.CostCenter', '');
        this.props.FormChange('inventoryCircuitCostAllocationForm.CompanyCode', '');
        this.props.FormChange('inventoryCircuitCostAllocationForm.Key', 0);
    }

    activateAddBtn() {
        if (this.state.glCode  && this.state.costCenter  && this.state.percent ) {
            this.setState({ enableAddBtn: true });
        } else {
            this.setState({ enableAddBtn: false });
        }
    }

    HandleOnChange(e, field) {
        const { value } = e.target;
        if (value === '' || /^\d*(\.\d*)?$/.test(value)) {
            this.setState({ [field]: value }, () => {
                this.activateAddBtn();
            });
        }
    }

    OnChangeGlCode = (e) => {
        const selectedOption = this.props.glcodeOptions.find(opt => opt.Key === e);

        const value = selectedOption ? selectedOption.Value : "";

        this.setState({
            selectedGlCodeKey: e,
            glCode: value,
            glCodeValid: true,
            isAddGLcode: false,
        },() => {
            this.activateAddBtn();
        });
    };

    OnChangeCostCenter = (e) => {
        const selectedOption = this.props.costcenterOptions.find(opt => opt.Key === e);

        const value = selectedOption ? selectedOption.Value : "";
        const companyCode = selectedOption ? selectedOption.Label : "";

        this.props.FormChange(`inventoryCircuitCostAllocationForm.CompanyCode`, companyCode);

        this.setState({
            selectedCostCenterKey: e,
            costCenter: value,
            costCenterValid: true,
            isAddGL_Cost: false,
        }, () => {
            this.activateAddBtn();
        });
    };

    clearSelectedValue = () => {
        this.setState({           
            selectedItems:{
                GLCode: "",
                GLCodeName:"",
                CostCode: "",
                CostCodePercent: "",
                CompanyCode: ""

            }
        });

        this.props.FormChange(`inventoryCircuitCostAllocationForm.Key`, 0);
    }

    updateCircuitCostAllocation = async (indexItem) => {
        let companyKey;
        const { inventoryCostAllocation, inventoryCircuitCostAllocationForm, costCodeListTable } = this.props;
        const { CostCode: _costCode, GLCode: _glCode, Key} = inventoryCircuitCostAllocationForm;
        const optionsMap = this.getOptionsMap();
        const currectCompanyCode = inventoryCostAllocation?.circuitCostAllocation?.datatable?.[0].dataItem[indexItem].CompanyCode;
        const currentKey = inventoryCostAllocation?.costCodeListTable.find(option => option.Label === currectCompanyCode)

        if(Key === 0){
            companyKey = currentKey?.Key;
        }else{
            companyKey = Key;
        }
        const _companyCode = inventoryCostAllocation?.costCodeListTable.find(option => option.Key === companyKey)?.Label;

        if (inventoryCostAllocation.circuitCostAllocation.datatable.length > 0) {
            const costAllocationItems = await inventoryCostAllocation.circuitCostAllocation?.datatable?.[0].dataItem.filter((item, index) => index !== indexItem);
            const isExisting = costAllocationItems.some(item => item.CostCode === _costCode && item.GLCode === _glCode && item.CompanyCode === _companyCode);

            if (isExisting) {
                this.setState({
                    haveError: true,
                    isExist: true,
                    showNotif: true,
                    isGreater: false,
                    isUpdateGl_Cost: true,
                    modalMessage: <Translation translationKey={"gl_cost_center_already_exist"} />
                });
                return
            } else {
                this.setState({
                    haveError: false,
                    isExist: false,
                    showNotif: false
                });
            }
        }

        var totalCostCodePercent = this.CalculateTotalCostCodePercent(parseFloat(inventoryCircuitCostAllocationForm.CostCodePercent) ?? 0, indexItem);

        if (totalCostCodePercent > 100) {
            this.setState({
                haveError: true,
                modalMessage: <Translation translationKey={"percentage_cannot_exceed"} />,
                glCodeValid: false,
                costCenterValid: false,
                showNotif: true,
                isGreater:true,
                isExist: false,
                isAddPercent: false,
                isUpdatePercent: true,
                isUpdateGl_Cost: false,
            });
            return;
        }

        if(!this.state.haveError) {
            this.setState({
                showModal: true,
                keyIndex:indexItem,
                isGreater:false,
                updateCostAllocationDetails: true,
            })
        }


    }

    updateError = (e) => {
        this.setState({
            isExist: e
        })
    }

    ResetError = (value) => {
        this.setState({
            haveError: value
        })
    }

    CalculateTotalCostCodePercent = (percent, indexItem) => {
        const { inventoryCostAllocation } = this.props;

        var costAllocationItems = [
            ...inventoryCostAllocation.circuitCostAllocation?.datatable?.[0].dataItem
        ];
        if (indexItem > -1) {
            costAllocationItems.splice(indexItem, 1);
        }
        var totalCostCodePercent = 0;

        if (costAllocationItems.length > 0) {
            totalCostCodePercent = costAllocationItems.reduce(
                (total, item) => total + parseFloat(item.CostCodePercent),
                parseFloat(percent)
            );
        }
        else {
            totalCostCodePercent = parseFloat(percent);
        }
        return totalCostCodePercent;
    }

    AddCircuitCostAllocation = () => {
        const {
            glCode, costCenter, percent, selectedCostCenterKey, 
            selectedGlCodeKey, haveError
        } = this.state;
    
        const { 
            inventoryCostAllocation, 
            inventoryCircuitCostAllocationForm
        } = this.props;
        const { activeTimeZoneOffset } = this.props.adminSetting;
        const newCompanyCode = this.props.costcenterOptions.find(option => option.Value === costCenter && option.Key === selectedCostCenterKey)?.Label;
        this.props.FormChange(`inventoryCircuitCostAllocationForm.CompanyCode`, newCompanyCode)
        const { CompanyCode: _companyCode } = inventoryCircuitCostAllocationForm;
        const dataItem = inventoryCostAllocation.circuitCostAllocation.datatable?.[0]?.dataItem || [];
    
        const data = {
            GLCode: glCode,
            CostCode: costCenter,
            CostCodePercent: percent,
            GLCodeName: '',
            CompanyCode: newCompanyCode,
            CostCodeID: selectedCostCenterKey,
            GLCodeID: selectedGlCodeKey,
            LastModified: `${sessionStorage.FirstName} ${sessionStorage.LastName} on 
                          ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('L')} ${Moment(convertToTimeZoneDate(new Date(),activeTimeZoneOffset?.UtcOffset)).format('LT')}`
        };
    
        const itemExists = dataItem.some(item => 
            item.CostCodeID === data.CostCodeID &&
            item.GLCodeID === data.GLCodeID &&
            item.CompanyCode === _companyCode
        );
        if (itemExists) {
            this.setState({
                haveError: true,
                isExist: true,
                showNotif: true,
                isGreater: false,
                isAddGL_Cost: true,
                modalMessage: <Translation translationKey={"gl_cost_center_already_exist"} />
            });
            return;
        } 
    
        const totalCostCodePercent = this.CalculateTotalCostCodePercent(percent);
    
        if (totalCostCodePercent > 100) {
            this.setState({
                haveError: true,
                showNotif: true,
                modalMessage: <Translation translationKey={"percentage_cannot_exceed"} />,
                isGreater: true,
                isExist: false,
                isAddPercent: true,
                isUpdatePercent: false,
            });
            return;
        }
    
        if (!haveError) {
            this.setState({
                showModal: true,               
                updateCostAllocationDetails: false,
                totalCostCodePercent: totalCostCodePercent,
                data: data
            });
        } else {
            this.setState({
                haveError: false,
                isExist: false,
                showNotif: false,
                modalMessage: ""
            });
        }
    };

    DeleteCircuitCostAllocation = (index) => {
        const { circuitCostAllocation } = this.props.inventoryCostAllocation;
        
        this.props.deleteCostAllocationDetails(index);
       
        const updateCostList = circuitCostAllocation
        let newTable = updateCostList?.datatable[0]?.dataItem;

        newTable.splice(index, 1); 

        this.props.handleChangesStatus('addCostChange', true)
        

        const containsObjectWithID =  hasObjectWithProperty(newTable, "CostAllocationID", -1);

            if(containsObjectWithID || this.state.tableLength !== newTable.length){
                this.props.handleChangesStatus('addCostChange', true)
            }else{
                this.props.handleChangesStatus('addCostChange', false)
            }
    };


    handleGetFieldData = async (field, data) => {
        const { gLCodeListTable, costCodeListTable } = this.props.inventoryCostAllocation;

        if (field === "GLCode") {
            const fullGlCodeOptions = gLCodeListTable || [];
            const glCodeOption = { Key: data.GLCodeID, Value: data.GLCode, Label: data.GLCodeName };

            const optionExists = fullGlCodeOptions.some(opt => opt.Key === glCodeOption.Key);

            const finalOptions = optionExists ? fullGlCodeOptions : [glCodeOption, ...fullGlCodeOptions];

            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCode`, data.GLCode)
            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCodeID`, data.GLCodeID)
            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCodeName`, data.GLCodeName)

            this.setState(prevState => ({
                selectedItems: {
                    ...prevState.selectedItems,
                    GLCodeName: data.GLCodeName,
                    GLCode: data.GLCodeID
                },
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": finalOptions
                }
            }));
        }

        if (field === "CostCode") {
            const fullCostCodeOptions = costCodeListTable || [];
            const costCodeOption = { Key: data.CostCodeID, Value: data.CostCode, Label: data.CompanyCode };

            const optionExists = fullCostCodeOptions.some(opt => opt.Key === costCodeOption.Key);

            const finalOptions = optionExists ? fullCostCodeOptions : [costCodeOption, ...fullCostCodeOptions];

            this.props.FormChange(`inventoryCircuitCostAllocationForm.CostCode`, data.CostCode)
            this.props.FormChange(`inventoryCircuitCostAllocationForm.CostCodeID`, data.CostCodeID)
            this.props.FormChange(`inventoryCircuitCostAllocationForm.CompanyCode`, data.CompanyCode)

            this.setState(prevState => ({
                selectedItems: {
                    ...prevState.selectedItems,
                    CompanyCode: data.CompanyCode,
                    CostCode: data.CostCodeID
                },
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": finalOptions
                }
            }));
        }

        if (field === "CostCodePercent") {
            const percent = parseFloat(data.CostCodePercent || 0);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.CostCodePercent`, data.CostCodePercent);

            this.setState(prevState => ({
                selectedItems: {
                    ...prevState.selectedItems,
                    CostCodePercent: percent,
                },
                percentValue: percent,
                fieldChange: true,
            }));
        }
    };

    handleSelectChange = async (field, e, index) => {
        const { gLCodeListTable, costCodeListTable } = this.props.inventoryCostAllocation;

        const newKey = e?.Key ?? e;

        if (field === "CostCode") {

            const companyCode = costCodeListTable.find(x => x.Key === newKey)?.Label;
            const companyValue = costCodeListTable.find(x => x.Key === newKey)?.Value;

            this.props.FormChange(`inventoryCircuitCostAllocationForm.CompanyCode`, companyCode);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.CostCode`, companyValue);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.CostCodeID`, e);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.Key`, e);

            this.setState(prevState => ({
                selectedItems: {
                    ...prevState.selectedItems,
                    CompanyCode: companyCode,
                    CostCode: e
                }
            }));
        }

        if (field === "GLCode") {
            const selectedLabel = gLCodeListTable.find(option => option.Key === newKey)?.Label;
            const selectedValue = gLCodeListTable.find(option => option.Key === newKey)?.Value;
            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCodeName`, selectedLabel);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCode`, selectedValue);
            this.props.FormChange(`inventoryCircuitCostAllocationForm.GLCodeID`, e);

            this.setState(prevState => ({
                selectedItems: {
                    ...prevState.selectedItems,
                    GLCode: e,
                    GLCodeName: selectedLabel
                }
            }));
        }
    };

    handleInputChange(field,e) {
        var value=e.target.value;
        if (value === '' || /^\d*\.?\d*$/.test(value)) {           
            this.props.FormChange(`inventoryCircuitCostAllocationForm.${field}`, value)
            this.setState(prevState => ({
                ...prevState,
                selectedItems: {
                    ...prevState.selectedItems,
                    [field]: value
                },
                fieldChange: true,
                percentValue: value
            }));
        }
    };

    handleConfirmationModal = (buttonType) => {
        const { updateCircuitCostAllocationItem } = this.props;
        const { keyIndex } = this.state
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.props.handleChangesStatus('addCostChange', true);

            if(this.state.updateCostAllocationDetails) {
               updateCircuitCostAllocationItem(keyIndex);                
            } else {
                this.props.addCostAllocationDetails(this.state.data, this.state.totalCostCodePercent);
                this.setState({
                    glCode: '',
                    costCenter: '',
                    percent: '',                 
                    enableAddBtn: false,
                });
                this.resetMainForm();
            }

            this.setState( prev => ({
                showModal: !prev.showModal,
                enableEdit:false,
                updateCostAllocationDetails: false,
                isExist:false,
                isGreater:false
            }))

        }else{
            this.setState({
                showModal: false
            });
        }
    }

    handleCloseNotif = () =>{
        this.setState({showNotif:false});
    }

    handleOpenNotif = (title) =>{
        this.setState({
            showNotif: true,
            notifTitle: title
        });
    }

    onClickAdd = () =>{       
        this.AddCircuitCostAllocation()
    }

    modifyOption = (options) => {
        if (options) {
            return options.map(option => ({
                ...option,
                Value: `${option.Value} ~ ${option.Label}`
            }));
        }
    }

    formatTotalCostCodePercent(totalCostCodePercent) {
        if (Number.isInteger(totalCostCodePercent)) {
            return `${totalCostCodePercent}%`;
            } else {
            const decimalPart = totalCostCodePercent.toString().split('.')[1];
            const decimalPlaces = decimalPart ? Math.min(decimalPart.length, 50) : 0;
            return `${totalCostCodePercent.toFixed(decimalPlaces)}%`;
        }
}

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown })); 
    }

    handelEnableEdit = (enable,index) =>{
        this.setState({enableEdit:enable, keyIndex:index})
    }
    onTableSearchChange = async (query, propName) => {

        if (propName === "GLCode") {
            await this.props.getTableCircuitGlCodeList(1, query);
            const { gLCodeListTable } = this.props.inventoryCostAllocation;

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": gLCodeListTable
                }
            }));
        }
        else if (propName === "CostCode") {
            await this.props.getTableCircuitCostCenterList(1, query);
            const { costCodeListTable } = this.props.inventoryCostAllocation;

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": this.modifyOption(costCodeListTable)
                }
            }));
        }
    };

    onTableLoadMore = (searchString, propName) => {
        if (propName === "GLCode") {
            const { tableGLCodePage, gLCodeListTable, limitRenderGlCode } = this.props.inventoryCostAllocation;

            if (limitRenderGlCode === 1) {
                this.props.getTableCircuitGlCodeList(tableGLCodePage + 1, searchString, 1);
            }

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "GLCode": gLCodeListTable
                }
            }));
        }
        else {
            const { tableCostCodePage, costCodeListTable, limitRenderCostCode } = this.props.inventoryCostAllocation;

            if (limitRenderCostCode === 1) {
                this.props.getTableCircuitCostCenterList(tableCostCodePage + 1, searchString, 1);
            }

            this.setState(prevState => ({
                optionsMap: {
                    ...prevState.optionsMap,
                    "CostCode": this.modifyOption(costCodeListTable)
                }
            }));
        }
    };

    isTableDropDownLoading = (propName) => {
        return propName === "GLCode"
            ? this.props.inventoryCostAllocation?.isTableGLCodeLoading
            : this.props.inventoryCostAllocation?.isTableCostCenterLoading;
    };

    hasTableDropdownMore = (propName) => {
        return propName === "GLCode"
            ? this.props.inventoryCostAllocation?.hasMoreTableGLCode
            : this.props.inventoryCostAllocation?.hasMoreTableCostCode;
    };

    setCostAllocationForm = (propName) => {
        const { inventoryCircuitCostAllocationForm } = this.props;
        return propName === "GLCode" ? inventoryCircuitCostAllocationForm.GLCode : inventoryCircuitCostAllocationForm.CostCode;
    }

    getOptionsMap = () => {
        const { inventoryCostAllocation } = this.props;

        return {
            GLCode: inventoryCostAllocation?.gLCodeListTable || [],
            CostCode: this.modifyOption(inventoryCostAllocation?.costCodeListTable) || []
        };
    };

    render() {

        const { translator, glcodeOptions, costcenterOptions, inventoryCircuitCostAllocationForm, updateCircuitCostAllocationItem, AddCircuitCostAllocation, hasPendingApproval, requestTypeId, isCircuitOrder, completed } = this.props;
        const { circuitCostAllocation } = this.props.inventoryCostAllocation;

        const addUpdateAction = this.state.updateCostAllocationDetails ? this.deleteCostAllocationDetails : this.AddCircuitCostAllocation;
        const enableAddUpdateBtn = inventoryCircuitCostAllocationForm.GLCode && inventoryCircuitCostAllocationForm.CostCenter && inventoryCircuitCostAllocationForm.Percent;

        const noAddFunction = isCircuitOrder && requestTypeId == REQUEST_TYPES_ID.subscriptionCancellation
            || requestTypeId == REQUEST_TYPES_ID.portOut
            || requestTypeId == REQUEST_TYPES_ID.InternationalRoamingAccess
            || requestTypeId == REQUEST_TYPES_ID.terminateSubscriptionWireline
            || requestTypeId == REQUEST_TYPES_ID.CallingAccess;
    
        const sectionTitle = noAddFunction ? <Translation translationKey={"cost_allocation"}/> : <Translation translationKey={"add_cost_allocation"}/>;
        const optionsMap = this.getOptionsMap();

        const modifiedCostcenterOptions = this.modifyOption(costcenterOptions);

        const sortedData = (circuitCostAllocation?.datatable || []).map(item => {
            return {
                ...item,
                dataItem: (item.dataItem || []).sort((a, b) => {
                    if (a.GLCode < b.GLCode) return -1;
                    if (a.GLCode > b.GLCode) return 1;
                    if (a.GLCode === b.GLCode) {
                        if (a.CostCode < b.CostCode) return -1;
                        if (a.CostCode > b.CostCode) return 1;
                    }
                    return 0;
                }),
            };
        });


        return (
            <>
                <CustomDropdown
                    label={sectionTitle} 
                    activeDropdown={this.state.activeDropdown} 
                    toggleActiveState={this.toggleActiveState} 
                >
                    <div className= "add-sim-container add-cost-allocation-cont">
                        <div className="details-4-col-26-container">
                            <NotificationModal 
                                show={this.state.showNotif} 
                                title={this.state.haveError ? 'Error' : 'Success'} 
                                message={ this.state.modalMessage ? this.state.modalMessage : `Cost allocation ${this.state.notifTitle} successfully!`}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />
                            <CustomSearchableDropdownWrapper
                                label={<Translation translationKey={"capital_gl_code"} />}
                                options={glcodeOptions}          
                                selected={this.state.glCode || ""}    
                                onChange={this.OnChangeGlCode}         
                                placeholder={isDisabledPerRequestType(requestTypeId, 'GLCode') ? '' : `${translator("select_placeholder")}`}
                                customClass={`${this.state.isExist && this.state.isAddGL_Cost ? 'border-red' : ''}
                                              ${!isDisabledPerRequestType(requestTypeId, 'GLCode') ? 'required' : ''}`}
                                fieldProp={`inventoryCircuitCostAllocationForm.GLCode`}  
                                tagName={`inventoryCircuitCostAllocationForm.GLCode`}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                                //requiredField={!isDisabledPerRequestType(requestTypeId, 'GLCode')}
                                maxLength={MAX_LENGTH.limit_100}
                                disabled={completed || isDisabledPerRequestType(requestTypeId, 'GLCode')}
                                onSearchChange={this.props.handleGlCodeSearch}
                                onLoadMore={this.props.loadMoreGlCode}            
                                isLoading={this.props.isGLCodeLoading}   
                                hasMore={this.props.hasMoreGLCode}     
                            />

                            <CustomSearchableDropdownWrapper
                                label={<Translation translationKey={"capital_cost_center"} />}
                                options={modifiedCostcenterOptions}
                                selected={this.state.costCenter || ""}
                                onChange={this.OnChangeCostCenter}
                                placeholder={isDisabledPerRequestType(requestTypeId, 'CostCenter') ? '' : `${translator("select_placeholder")}`}
                                customClass={`${this.state.isExist && this.state.isAddGL_Cost ? 'border-red' : ''}
                                              ${!isDisabledPerRequestType(requestTypeId, 'CostCenter') ? 'required' : ''}`}
                                disabled={completed || isDisabledPerRequestType(requestTypeId, 'CostCenter')}
                                maxLength={MAX_LENGTH.limit_100}
                                fieldProp={"inventoryCircuitCostAllocationForm.CostCenter"}
                                tagName={`inventoryCircuitCostAllocationForm.CostCenter`}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}
                               // requiredField={!isDisabledPerRequestType(requestTypeId, 'CostCenter')}
                                onSearchChange={this.props.handleCostCenterSearch}
                                onLoadMore={this.props.loadMoreCostCenter}
                                isLoading={this.props.isCostCenterLoading}
                                hasMore={this.props.hasMoreCostCenter}
                            />

                            <InputField
                                label={<Translation translationKey={"percent"} />}
                                inputValue={this.state.percent}
                                onChange={(e) => this.HandleOnChange(e, 'percent')}                           
                                requiredField={!isDisabledPerRequestType(requestTypeId, 'percent')}
                                customWrapper={this.state.isGreater & this.state.isAddPercent ? 'border-red' : ''}
                                placeholder={isDisabledPerRequestType(requestTypeId, 'percent') ? '' : `${translator("enter_text_placeholder")}`}
                                maxLength={MAX_LENGTH.inputText}
                                disabled={completed || isDisabledPerRequestType(requestTypeId, 'percent')}
                            />

                            <div className="add-button-container custom-add-button">

                                {!noAddFunction &&
                                    <div className="btn-tooltiptext">
                                        <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                                        <span className="tooltip-text">{<Translation translationKey="cancel_add_cost_allocation" />}</span>
                                    </div>
                                }

                                <ConfirmationNotificationModal 
                                    show={this.state.showModal} 
                                    message={this.state.updateCostAllocationDetails ? 'Are you sure you want to update?' : 'Are you sure you want to add?'} 
                                    title={this.state.updateCostAllocationDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />

                                {!noAddFunction &&
                                    <div className={'btn-tooltiptext'}>                               
                                        <Button 
                                            disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval : !this.state.enableAddBtn} 
                                            onClick={this.onClickAdd}
                                            variant="primary"
                                            className="btn-add"
                                        >
                                            {`${ACTION_TYPES.Add}`}

                                        </Button>
                                        <span className="tooltip-text"><Translation translationKey="add_cost_allocation_details" /></span>
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="details-table-container ">

                            <TableWithButton
                                datatable={sortedData}
                                haveDeleteBtn={completed || noAddFunction ? false : (this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false)))}
                                haveEditBtn={completed || noAddFunction ? false : (this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false)))}
                                deleteAction={this.DeleteCircuitCostAllocation}
                                updateAction={this.updateCircuitCostAllocation}
                                searchableDropdownData={["GLCode", "CostCode"]}
                                inputField={["CostCodePercent"]}
                                optionsMap={this.state.optionsMap}
                                selectedItems={this.state.selectedItems}
                                selectedValue={this.state.selectedValue}
                                percentValue={this.state.percentValue}
                                handleSelectChange={this.handleSelectChange.bind(this)}
                                handleInputChange={this.handleInputChange.bind(this)}
                                handleOpenNotif={this.handleOpenNotif}
                                handleGetFieldData={this.handleGetFieldData.bind(this)}
                                handelEnableEdit={this.handelEnableEdit}
                                enableEdit={this.state.enableEdit}
                                keyIndex={this.state.keyIndex}
                                clearSelectedValue={this.clearSelectedValue}
                                isUpdatePercent={this.state.isUpdatePercent}
                                isGreater={this.state.isGreater}
                                costAllocationForm={this.setCostAllocationForm}
                                isUpdateGl_Cost={this.state.isUpdateGl_Cost}
                                handleCloseNotif={this.handleCloseNotif}
                                onSearchChange={this.onTableSearchChange}
                                onLoadMore={this.onTableLoadMore}
                                isLoading={(propName) => this.isTableDropDownLoading(propName)}
                                hasMore={(propName) => this.hasTableDropdownMore(propName)}
                                isExist={this.state.isExist}
                                updateError={this.updateError}
                            />

                            <div className="total-allocated-container">
                                <span className="allocated-label"><Translation translationKey={"total_percent_allocated"} /></span>
                                <span className={circuitCostAllocation.totalCostCodePercent < 100 ? "allocated-percent-less100" : "allocated-percent"}>
                                    {this.formatTotalCostCodePercent(circuitCostAllocation.totalCostCodePercent)}
                                </span>

                            </div>
                        </div>     
                        
                    </div>
                </CustomDropdown>
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(
            Object.assign({}, inventoryCostAllocationActions),
            dispatch
        ),
        FormChange: (Model, value) => {
           dispatch(actions.change(Model, value))
        }
    }
};

export default connect(
    state => {
        const { inventoryCostAllocation, adminSetting } = state;
        const { inventoryCircuitCostAllocationForm } = state.form;
        return {
            inventoryCostAllocation,
            inventoryCircuitCostAllocationForm,
            adminSetting
        };
    },
    mapDispatchToProps
)(AddCostAllocation);